<template>
	<div class="WordSection1">
		<h1>
			<span style="position: relative; z-index: 251659264">
				<span style="
                        left: 0px;
                        position: absolute;
                        top: -42px;
                        width: 827px;
                        height: 149px;
                    ">
					<img width="827" height="149" src="/images/marsilli_pp_title.png" />
				</span> </span>&nbsp;
		</h1>

		<h1>&nbsp;</h1>

		<h1>&nbsp;</h1>

		<br clear="ALL" />

		<h1>
			<span lang="EN-GB">Privacy Policy - (Navigation My.Marsilli)</span>
		</h1>

		<p class="MsoNormal">
			<span lang="EN-GB">This policy is provided pursuant to Legislative Decree 196/2003
				(as amended by Legislative Decree 101/2018, which adapted the
				national legislation to the GDPR - EU Regulation 2016/679) and
				<b>insofar as the interested party is a user of My.Marsilli
					platform.
				</b></span>
		</p>

		<h1>
			<span lang="EN-GB">WHO IS THE CONTROLLER OF PERSONAL DATA PROCESSING</span>
		</h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Marsilli S.p.A. (hereinafter the <b>&quot;Company&quot;</b>),
				with headquarters in Italy, Castelleone (CR), Via Per Ripalta
				Arpina 14.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company is the Data Controller of the personal data
				collected.
			</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The list of the data processors is available at the above
				mentioned headquarters of the Company.</span>
		</p>

		<h1><span lang="EN-GB">CONTACTS</span></h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The contact details of the Company, as data controller, can be
				requested at the following e-mail address:
				privacy@marsilli.it</span>
		</p>

		<h1><span lang="EN-GB">WHAT PERSONAL DATA MAY BE COLLECTED </span></h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The following categories of personal data about you may be
				collected.</span>
		</p>

		<p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><strong><span lang="EN-GB" style="color: #1a171b">Contact details</span></strong><span lang="EN-GB" style="color: #1a171b">
				– information relating to name, title, telephone number, mobile
				number, e-mail address.</span>
		</p>

		<p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><strong><span lang="EN-GB" style="color: #1a171b">Log files on My.Marsilli Platform</span></strong><span lang="EN-GB">–<span style="color: #1a171b">
					IP address, name of the internet service provider (ISP),
					type of browser and parameters used, information regarding
					date and time of access to the platform, pages visited and
					activities carried out</span></span>
		</p>

		<h1><span lang="EN-GB">HOW WE COLLECT PERSONAL DATA</span></h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company collects and processes your personal data in the
				following circumstances:</span>
		</p>

		<p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">to request access to My.Marsilli;
			</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">to purchase our products, services, spare parts;</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">when you reply to our marketing campaigns;
			</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">through any mailing services found on My.Marsilli
				platform;</span>
		</p>

		<p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">when other companies of the Group or business partners lawfully
				transfer your personal data to us.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Please help us keep your personal data up-to-date, by notifying
				us should there be any changes.</span>
		</p>

		<h1>
			<span lang="EN-GB">FOR WHAT PURPOSES MAY PERSONAL DATA BE USED</span>
		</h1>

		<p class="MsoListParagraph" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<strong><span lang="EN-GB" style="color: #1a171b">a)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><strong><span lang="EN-GB" style="color: #1a171b">Use of My.Marsilli platform and its services</span></strong>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company may process your personal data for following
				purposes:
			</span>
		</p>

		<p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">to allow access to the platform and assign an account: User and
				Password and consequently manage any malfunctions of the account
				or the platform itself</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #1a171b">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #1a171b">to allow you to browse through the services and pages of the
				platform</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<strong><span lang="EN-GB" style="
                        font-family: Symbol;
                        color: #1a171b;
                        font-weight: normal;
                    ">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><span lang="EN-GB" style="color: #1a171b">to reply to requests (e.g. requ<strong><span style="font-weight: normal">est for spare parts, request for onsite visit
						for
						maintenance/service) received through the use of the
						platform's services</span></strong></span>
		</p>

		<p class="MsoListParagraphCxSpMiddle">
			<strong><span lang="EN-GB" style="color: #1a171b; font-weight: normal">&nbsp;</span></strong>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<strong><span lang="EN-GB" style="
                        font-family: Symbol;
                        color: #1a171b;
                        font-weight: normal;
                    ">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><strong><span lang="EN-GB" style="color: #1a171b; font-weight: normal">get statistical information on the use of the website (e.g.
					analysis of the pages visited)</span></strong>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<strong><span lang="EN-GB" style="
                        font-family: Symbol;
                        color: #1a171b;
                        font-weight: normal;
                    ">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><strong><span lang="EN-GB" style="color: #1a171b; font-weight: normal">to find statistical information and policies on most viewed
					products</span></strong>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<strong><span lang="EN-GB" style="
                        font-family: Symbol;
                        color: #1a171b;
                        font-weight: normal;
                    ">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><strong><span lang="EN-GB" style="color: #1a171b; font-weight: normal">log files data is collected to also guarantee
					functionality, security of the site, of the networks and
					information.
				</span></strong>
		</p>

		<p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
			<strong><span lang="EN-GB" style="
                        font-family: Symbol;
                        color: #1a171b;
                        font-weight: normal;
                    ">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><strong><span lang="EN-GB" style="color: #1a171b; font-weight: normal">no data is used for profiling user/customer, meant as an
					analysis of personal preferences or tastes, as our product
					and the activities connected to the product, are not for
					direct personal use.</span></strong>
		</p>

		<p class="MsoNormal">
			<u><span lang="EN-GB" style="color: #1a171b">Prerequisite to processing</span></u><span lang="EN-GB" style="color: #1a171b">: consent</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Non-conferment of said consent will not have consequences on
				the contractual relationship.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Consent may be revoked at any time.</span>
		</p>

		<p class="MsoNormal">
			<strong><span lang="EN-GB" style="color: #1a171b; font-weight: normal">&nbsp;</span></strong>
		</p>

		<p class="MsoNormal">
			<strong><i><span lang="EN-GB" style="color: #1a171b; font-weight: normal">The following purposes are consequent to the activities
						carried out on the platform, such as: b) request for
						offer and consequent order, c) participation to
						marketing campaigns or statistical analyses, d) possible
						disputes that may arise in the established relationship
					</span></i></strong>
		</p>

		<p class="MsoListParagraph" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<b><span lang="EN-GB" style="color: #1a171b">b)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></b><strong><span lang="EN-GB" style="color: #1a171b">Establishment and execution of the contractual
					relationships and resulting obligations, including
					communications relating to services. (e.g. to process
					purchase orders).</span></strong>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company may process your Contact data for the purposes of
				possible establishment and execution of contractual
				relationships, to provide requested services and to give
				feedback following reports and complaints.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company may furthermore process your Contact data, in
				particular your e-mail address, to provide you with information
				regarding services to be rendered.</span>
		</p>

		<p class="MsoNormal">
			<u><span lang="EN-GB" style="color: #1a171b">Prerequisite to processing</span></u><span lang="EN-GB" style="color: #1a171b">: fulfilment of the contractual obligations.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The provision of data is mandatory to be able to manage the
				contractual relationship; it would not be possible for us to
				proceed in lack of this data.</span>
		</p>

		<p class="MsoListParagraph" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<strong><span lang="EN-GB" style="color: #1a171b">c)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></strong><strong><span lang="EN-GB" style="color: #1a171b">Marketing to meet your requirements
				</span></strong>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company may process your contact data for marketing and
				advertising purposes, to inform you about sales initiatives, by
				means of automated (e-mail, SMS, and other messaging tools) and
				traditional contact systems (for example by telephone or mail)
				or also to carry out market research and statistical surveys,
				provided you give your specific consent.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company may also process the Collected Data and other
				personal data that you may wish to provide, to send commercial
				communications.
			</span>
		</p>

		<p class="MsoNormal">
			<u><span lang="EN-GB" style="color: #1a171b">Prerequisite to processing</span></u><span lang="EN-GB" style="color: #1a171b">: consent</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Non-conferment of said consent will not have consequences on
				the contractual relationship.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Consent may be revoked at any time.</span>
		</p>

		<p class="MsoListParagraph" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<b><span lang="EN-GB" style="color: #1a171b">d)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></b><strong><span lang="EN-GB" style="color: #1a171b">Legal disputes, compliance to legally binding requirements
					to fulfil a legal obligation
				</span></strong>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company collects your Contact data to fulfil a legal
				obligation and/or to defend their rights in a court of
				law.</span>
		</p>

		<p class="MsoNormal">
			<u><span lang="EN-GB" style="color: #1a171b">Prerequisite for processing</span></u><span lang="EN-GB" style="color: #1a171b">: legal obligations to which the Company must comply.</span>
		</p>

		<h1>
			<span lang="EN-GB">HOW WE STORE AND PROTECT PERSONAL DATA</span>
		</h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="font-size: 10.5pt; line-height: 115%; color: #1a171b">All your personal data is stored in both our computer and hard
				copy archives, or in those of </span><span lang="EN-GB" style="color: #1a171b">our archive service providers. They are accessible and usable
				according to our standards and our IT security policies.
			</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">&nbsp;</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">&nbsp;</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The personnel authorized to process your data in accordance
				with the Privacy Policy is duly trained and authorized in
				function of the activities to be carried out and the tasks
				assigned.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The Company uses all the necessary security measures to
				guarantee security, confidentiality, integrity and availability
				of your personal data by means of a security system ISO/IEC
				27001 certified.</span>
		</p>

		<h1><span lang="EN-GB">HOW LONG INFORMATION IS STORED</span></h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">We store your personal data only for the time necessary to
				achieve the purposes for which it was collected or for any
				legitimate related purpose. Therefore, if personal data is
				processed for two different purposes, we will store the data for
				a period of time equivalent to the purpose with the longer term.
				However, your personal data will no longer be processed for the
				purpose whose retention period has ceased.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">The access to your personal data is limited to personnel who
				need to process it for relevant purposes.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Personal data that is no longer necessary, or for which there
				is no legal requirement for storing it, is irreversibly
				anonymised (and in this way it can be stored) or securely
				destroyed.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Below are the storage times in relation to the different
				purposes listed above:</span>
		</p>

		<p class="MsoListParagraphCxSpFirst" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<b><span lang="EN-GB" style="color: #1a171b">a)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></b><u><span lang="EN-GB" style="color: #1a171b">Use of My.Marsilli and its services:
				</span></u><span lang="EN-GB" style="color: #1a171b">data processed for the use of the platform and its services may
				be retained until consent is revoked by the user/customer or by
				the employer of the user/customer, the statistical information
				data will be kept for the time necessary to carry out the
				indicated activities and no longer than 24 months.
			</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<b><span lang="EN-GB" style="color: #1a171b">b)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></b><u><span lang="EN-GB" style="color: #1a171b">Fulfilment of the contractual obligations:</span></u><span lang="EN-GB" style="color: #1a171b">
				data processed to fulfil any contractual obligation may be
				stored for the entire duration of the contract, and in any case
				no longer than the following 10 years, with the intent to verify
				possible outstanding matters including accounting documents.
			</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<b><span lang="EN-US" style="color: #1a171b">c)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></b><u><span lang="EN-GB" style="color: #1a171b">Marketing Purposes:
				</span></u><span lang="EN-GB" style="color: #1a171b">Personal data processed with marketing purposes may be retained
				until consent is revoked. </span><span lang="EN-US" style="color: #1a171b">Every marketing activity provides the possibility to revoke
				consent.</span>
		</p>

		<p class="MsoListParagraphCxSpLast" style="margin-left: 21.3pt; text-indent: -21.3pt">
			<b><span lang="EN-GB" style="color: #1a171b">d)<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					</span></span></b><u><span lang="EN-GB" style="color: #1a171b">In case of legal disputes
				</span></u><span lang="EN-GB" style="color: #1a171b">: should it be necessary to defend ourselves or to act or
				submit claims against yourself or third parties, we can retain
				personal data that we consider reasonably necessary to process
				for such purposes, for the possible duration of said
				claim.</span>
		</p>

		<h1><span lang="EN-GB">WHO MAY WE SHARE PERSONAL DATA WITH</span></h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Your personal data can be accessed by salespersons, duly
				authorized employees as well as external suppliers, nominated,
				if necessary, as responsible for the processing of personal data
				and who give support in providing services.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #1a171b">Your data may also be transferred to companies within the
				Marsilli Group, including those outside the EU; in this case,
				the controller will verify the respect of articles 44 and 45 of
				the GDPR.</span>
		</p>

		<h1>
			<span lang="EN-GB">&nbsp;DATA PROTECTION RIGHTS AND THE RIGHT TO SUBMIT A CLAIMS
			</span>
		</h1>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #262626">Pursuant to the GDPR, the Company would also like to inform you
				that - where the conditions exist - you can exercise the
				following rights:</span>
		</p>

		<p class="MsoListParagraphCxSpFirst" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to access your personal data;</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to copy the personal data you provided (so-called
				portability);</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to rectify data held by the Company</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to erase any data for which there is no longer a legal
				prerequisite for its processing;</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to revoke your consent if the processing is based on consent or
				if it is directly related to a direct marketing activity;</span>
		</p>

		<p class="MsoListParagraphCxSpMiddle" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to restrict the way your personal data is processed, within the
				limits required by the legislation on the protection of personal
				data.</span>
		</p>

		<p class="MsoListParagraphCxSpLast" style="text-indent: -18pt">
			<span lang="EN-GB" style="font-family: Symbol; color: #262626">·<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				</span></span><span lang="EN-GB" style="color: #262626">to object to processing when provided by the applicable
				legislation.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #262626">&nbsp;</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #262626">The exercise of these rights is subject to a few exceptions
				aimed at safeguarding public interests (for example the
				prevention or identification of criminal offences) and our
				interests (for example maintaining professional secrecy) Should
				you exercise any of the above mentioned rights, it will be our
				duty to verify that you are entitled to exercise this right and
				we will provide feedback, generally, within a month.
			</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #262626">For any complaints or claims you have the right to contact
				controlling authorities.</span>
		</p>

		<h1><span lang="EN-GB">CHANGES TO THIS PRIVACY POLICY</span></h1>

		<p class="MsoNormal" align="left" style="text-align: left">
			<span lang="EN-GB" style="color: #262626">The data controller reserves the right to make changes to this
				privacy policy at any time, giving notice to the Users on its
				website: www.marsilli.com <br />
				<br />
				Should changes pertain to processing whose legal basis is
				consent, the Data Controller if necessary, will request User's
				consent again.</span>
		</p>

		<p class="MsoNormal">
			<span lang="EN-GB" style="color: #262626">&nbsp;</span>
		</p>

		<h1>
			<span lang="EN-GB" style="color: #262626">CONSENT TO PROCESSING</span>
		</h1>

		<p class="MsoNormal" style="margin-bottom: 10pt">
			<span lang="EN-GB" style="color: #262626">This website processes data based on consent. To use or view
				the platform the users need to approve this privacy policy and
				consent to the processing of their personal data in relation to
				the processes and the purposes described above.</span>
		</p>

		<p class="MsoNormal" style="margin-bottom: 10pt">
			<span lang="EN-GB" style="color: #262626">Conferment of data and therefore of Consent to the collection
				and processing of the data is mandatory to be able to access and
				navigate on the platform. This consent is valid until a written
				revocation is sent via e-mail to: privacy@marsilli.it</span>
		</p>
		<p class="MsoNormal" v-if="logged">
			-
			<input type="checkbox" :disabled="privacyOK" :checked="!!privacyOK" @input="() => setPrivacy()" />
			-
			<span style="color: #262626">
				I authorize the treatment of my personal data</span>
		</p>
	</div>
</template>
<script>
import { API } from "@/api.js";
export default {
	name: "Privacy",
	data() {
		return {};
	},
	async mounted() { },
	computed: {
		logged() {
			console.log("logged app", this.$store.getters.userId);
			return !!this.$store.getters.userId;
		},
		privacyOK() {
			let pok = this.$store.getters.privacyOK;
			console.log("privacyOK?", pok);
			return pok;
		},
	},
	methods: {
		setPrivacy() {
			// posso solo settarla
			API.setPrivacy(1);
			this.$store.commit("privacyOK", null);
		},
	},
};
</script>
<style>
div.privacy {
	margin: 50px;
	max-width: 827px;
	position: relative;
	right: 0px;
	left: 0px;
	top: 30px;
	margin: auto;
	margin-bottom: 50px;
}

@media (min-width: 576px) {
	.modal-dialog {
		max-width: 500px;
		margin: 1.75rem auto;
	}
}

@media (min-width: 992px) {

	.modal-lg,
	.modal-xl {
		max-width: 860px;
	}
}

@media (min-width: 1200px) {
	.modal-xl {
		max-width: 1140px;
	}
}

p.MsoNormal,
li.MsoNormal,
div.MsoNormal {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 6pt;
	margin-left: 0cm;
	text-align: justify;
	line-height: 115%;
	font-size: 10pt;
	font-family: "Calibri", sans-serif;
}

div.WordSection1 h1 {
	mso-style-link: "Titolo 1 Carattere";
	margin-top: 12pt;
	margin-right: 0cm;
	margin-bottom: 0cm;
	margin-left: 0cm;
	text-align: justify;
	line-height: 115%;
	page-break-after: avoid;
	font-size: 12pt;
	font-family: "Calibri", sans-serif;
	color: black;
	font-weight: bold;
}

div.WordSection1 strong {
	font-style: normal;
}

p.MsoListParagraph,
li.MsoListParagraph,
div.MsoListParagraph {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 6pt;
	margin-left: 36pt;
	text-align: justify;
	line-height: 115%;
	font-size: 10pt;
	font-family: "Calibri", sans-serif;
}

p.MsoListParagraphCxSpFirst,
li.MsoListParagraphCxSpFirst,
div.MsoListParagraphCxSpFirst {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 0cm;
	margin-left: 36pt;
	text-align: justify;
	line-height: 115%;
	font-size: 10pt;
	font-family: "Calibri", sans-serif;
}

p.MsoListParagraphCxSpMiddle,
li.MsoListParagraphCxSpMiddle,
div.MsoListParagraphCxSpMiddle {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 0cm;
	margin-left: 36pt;
	text-align: justify;
	line-height: 115%;
	font-size: 10pt;
	font-family: "Calibri", sans-serif;
}

p.MsoListParagraphCxSpLast,
li.MsoListParagraphCxSpLast,
div.MsoListParagraphCxSpLast {
	margin-top: 0cm;
	margin-right: 0cm;
	margin-bottom: 6pt;
	margin-left: 36pt;
	text-align: justify;
	line-height: 115%;
	font-size: 10pt;
	font-family: "Calibri", sans-serif;
}

div.WordSection1 span.Titolo1Carattere {
	mso-style-name: "Titolo 1 Carattere";
	mso-style-link: "Titolo 1";
	font-family: "Times New Roman", serif;
	color: black;
	font-weight: bold;
}

.MsoChpDefault {
	font-family: "Calibri", sans-serif;
}

.MsoPapDefault {
	margin-bottom: 10pt;
	line-height: 115%;
}

/* Page Definitions */
@page WordSection1 {
	size: 595.3pt 841.9pt;
	margin: 70.85pt 2cm 2cm 2cm;
}

div.WordSection1 {
	page: WordSection1;
}

/* List Definitions */
div.WordSection1 ol {
	margin-bottom: 0cm;
}

div.WordSection1 ul {
	margin-bottom: 0cm;
}
</style>
